<template>
  <div id="app">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.2.0/css/all.css" integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ" crossorigin="anonymous">
    <div id="nav" v-if="authenticated">
      <div class="vybrok"> <md-field>
        <label for="roky">Rok</label>
        <md-select v-model="roky" name="roky" id="roky"  @md-selected="zmenaRoku()">
          <md-option v-for="year in  yearss" :key="year" :value="year"  >{{year}}</md-option>
        </md-select></md-field>
      </div>
      <md-button class="odhlassa"><router-link  to="/login" v-on:click.native="logout()" replace> <i class="fas fa-sign-out-alt"></i> Odhlásiť sa</router-link></md-button><span class="memn"> Vitaj {{menoje}}</span></div>

    <div id="vedlajsiemenu"  v-if="authenticated">
      <img src="~@/assets/images/doprava_preprava_limousintravelpng.png" alt="CMS" />
      <md-button>  <router-link  to="/dashboard" replace> <i class="far fa-chart-bar"></i> Dashboard</router-link></md-button>
    </div>


    <router-view @authenticated="setAuthenticated" />
  </div>
</template>

<script>
  import store from "./store";

  export default {
    name: "App",
    data() {
      return {
        authenticated: false,
        menoje:'',
        roky:new Date().getFullYear(),
        suroky:'',
        datasu:'',

      }

    },
    beforeCreate() {
      if(this.authenticated=== false) {
        window.location.href = '/#/';
        localStorage.clear();
      }else{
        window.location.href = '/#/dashboard';
      }

      /*pridaj rokz od 2018*/
      var rok = new Date().getFullYear();
      var years = [];
      for (var rokis = 2018; rokis <= rok; rokis++) {
        years.push(rokis);
      }
      this.yearss = years;

      //natiahne data do Vuexu
      var rok = new Date().getFullYear();
      for (var rokis = 2018; rokis <= rok; rokis++) {
        var suroky = suroky +','+ rokis;
      }
      this.$http.post('//adminli.limousintravel.eu/api/dashboard-graf.php',  { rok: suroky}).then(function (response) {
        var datasu = response.data;
        store.commit('ADD_GRAF',datasu);
      });


    },
    beforeUpdate() {
      store.commit('ADD_ROK',new Date().getFullYear());
      this.menoje = this.$localStorage.get("meno");
      if(this.authenticated === false) {
        window.location.href = '/#/';
        localStorage.clear();
      }
    },
    methods: {

      setAuthenticated(status) {
        this.authenticated = status;

      },
      logout() {
        this.authenticated = false;
        localStorage.clear();
        /* store.commit('ADD_GRAF',false);
         store.commit('ADD_ROK',false);*/
        window.location.href = '/#/';

      },
      zmenaRoku(){
        store.commit('ADD_ROK',this.roky);
        window.location.href = '/#/dashboard';
      }

    }
  }

</script>

<style  lang="scss" >

  body{
    min-height: auto !important;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  #nav{
    position: fixed;
    top: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    z-index: 1;
    border-bottom: 1px solid rgba(0,0,0,.15);
  }
  .vybrok{
    float: left;
    width: 150px;
    margin-left: 271px;
    .md-field{
      margin: 0px;
      :after, :before{
        display: none;
      }
    }
  }

  .md-progress-bar.md-theme-default.md-indeterminate .md-progress-bar-track:after, .md-progress-bar.md-theme-default.md-indeterminate .md-progress-bar-fill:after, .md-progress-bar.md-theme-default.md-query .md-progress-bar-track:after, .md-progress-bar.md-theme-default.md-query .md-progress-bar-fill:after{
      background-color: #0bcca8;
  }

  .odhlassa{
    float:right;
    text-transform: initial;

    a:not(.md-button):hover{
      text-decoration: none;
    }
  }
  .memn{
    float:right;
    margin: 14px 15px 0 0;
  }


  .vue-notification {
    padding: 10px;
    margin: 10px;
    font-size: 12px;
    color: #ffffff;
    background: #44A4FC;
    border-left: 5px solid #187FE7;

    .warn {
      background: #ffb648;
      border-left-color: #f48a06;
    }

    .error {
      background: #E54D42;
      border-left-color: #B82E24;
    }
    .success{
      background: #68cd86;
      border-left-color: #42a85f;
    }}
  #vedlajsiemenu{
    color: rgba(255,255,255,.8);
    width: 250px;
    position: fixed;
    left: 0;
    height: 100%;
    background-color: #495468;
    z-index: 1;
    top: 0;

    img{
      min-width: 250px;
      margin: 20px auto;
      display: block;
    }

    .md-button{
      width: 100%;
      margin: 0px;
      border-bottom: 1px solid #7b89a4;
      text-transform: initial;

      a{
        color: #fff;
      }
      a:not(.md-button):hover{
        text-decoration: none;
      }
      .md-ripple {
        padding: 0 15px  !important;
        justify-content: inherit !important;
      }

    }
  }
</style>
